/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2024-12-25 16:26:07.

export interface CreateAgentAccountDto {
    accountStatus: AccountStatus;
    currency: string;
    bban: string;
    iban: string;
    swift: string;
    correspondentBank: string;
    foreignPaymentRecipient: string;
    canBeBlocked: boolean;
    purposeDescription: string;
    konto: string;
    accountType: AccountType;
    agentId: string;
    bankId: string;
}

export interface UpdateAgentAccountDto {
    id: string;
    accountStatus: AccountStatus;
    currency: string;
    bban: string;
    iban: string;
    swift: string;
    correspondentBank: string;
    foreignPaymentRecipient: string;
    canBeBlocked: boolean;
    purposeDescription: string;
    konto: string;
    accountType: AccountType;
    agentId: string;
    bankId: string;
}

export interface CreateDeactivationRequestDto {
    id: string;
    accountId: string;
}

export interface WebUUIDResponse {
    result: string; problemResponseData?: ProblemResponseData|null;
}

export interface WebStringResponse extends WebResponseEntity<string> {
    result: string; problemResponseData?: ProblemResponseData|null;
}

export interface VerificateAgentAccountDeactivationRequestDto {
    id: string;
    deactivationRequestStatus: DeactivationRequestStatus;
}

export interface CreateAgentCategoryDto extends AgentCategoryCommonDto {
}

export interface UpdateAgentCategoryDto extends AgentCategoryCommonDto {
    id: string;
}

export interface CreateAgentConfigurationDto extends ConfigurationCommonDto {
    agentId: string;
}

export interface CreateMultipleAgentConfigurationsDto {
    configurations: CreateAgentConfigurationDto[];
}

export interface UpdateConfigurationDto extends ConfigurationCommonDto {
    id: string;
}

export interface CreateAgentContactPersonDto extends ContactPersonCommonDto {
    agentId: string;
    address: CreateAddressDto;
}

export interface DeleteAgentContactDto {
    agentId: string;
    contactId: string;
}

export interface WebBooleanResponse {
    result: boolean; problemResponseData?: ProblemResponseData|null;
}

export interface UpdateAgentContactPersonDto extends ContactPersonCommonDto {
    agentId: string;
    id: string;
    address: UpdateAddressDto;
}

export interface CreateAgentContractDto {
    agentId: string;
    contractName: string;
    signingDate: DateAsString;
    referenceNumber: string;
    agentSignatory: string;
    masterAgentSignatory: string;
    masterAgentSigningDate: DateAsString;
    masterAgentReferenceNumber: string;
    contractDuration: DateAsString;
    documentHolderName: DocumentHolderDto;
    contractTypeId: string;
    contractKindId: string;
    reminder: ContractReminderDto;
    contactPerson: ContactPersonDto;
    agentContractSubjects: AgentContractSubjectDto[];
    automaticContractRenewal: boolean;
}

export interface AgentContractKindDto {
    name: string;
    description: string;
}

export interface AgentContractTypeDto {
    name: string;
    description: string;
}

export interface CreateAgentDto {
    isActive: boolean;
    businessEntity: BusinessEntity;
    address: CreateAddressDto;
    partyId: string;
    contact: ContactDto;
    statisticalGroupId: string;
    categoryId: string;
}

export interface CreateAgentFromPartyDto {
    partyId: string;
}

export interface UpdateAgentDto {
    id: string;
    businessEntity: BusinessEntityDto;
    address: UpdateAddressDto;
    contact: ContactDto;
    statisticalGroupId: string;
    categoryId: string;
}

export interface CreateAgentStatisticalGroupDto extends AgentStatisticalGroupCommonDto {
}

export interface UpdateAgentStatisticalGroupDto extends AgentStatisticalGroupCommonDto {
    id: string;
}

export interface CreateLocationConfigurationDto extends ConfigurationCommonDto {
    locationId: string;
}

export interface CreateMultipleLocationConfigurationsDto {
    configurations: CreateLocationConfigurationDto[];
}

export interface LocationAgentServiceDto {
    locationId: string;
    agentServiceId: string;
    agentId: string;
    serviceCode: number;
    version: number;
}

export interface CreateLocationDto {
    name: string;
    shortName: string;
    note: string;
    address: CreateAddressDto;
    contact: ContactDto;
    isActive: boolean;
    regionalManager: RegionalManagerDto;
    contactPerson1: ContactPersonCommonDto;
    contactPerson2: ContactPersonCommonDto;
    agentId: string;
}

export interface UpdateLocationExternalDataDto extends LocationExternalDataDto {
    locationId: string;
}

export interface UpdateLocationDto {
    id: string;
    name: string;
    shortName: string;
    note: string;
    address: UpdateAddressDto;
    contact: ContactDto;
    regionalManager: RegionalManagerDto;
    contactPerson1: ContactPersonCommonDto;
    contactPerson2: ContactPersonCommonDto;
}

export interface CreateLocationGroupDto {
    name: string;
    code: string;
}

export interface UpdateLocationGroupDto {
    id: string;
    name: string;
    code: string;
}

export interface CreateLocationWorkingDayDto {
    locationId: string;
    dayOfWeek: DayOfWeek;
    dayKind: DayKindEnum;
    workingTimes: WorkingTimeDto[];
}

export interface LocationAddDayDto {
    locationId: string;
    startTime: DateAsString;
    endTime: DateAsString;
    weekendDays: DayOfWeek[];
}

export interface UpdateLocationWorkingDayDto {
    id: string;
    dayKind: DayKindEnum;
    workingTimes: WorkingTimeDto[];
}

export interface CreateOperatorConfigurationDto extends ConfigurationCommonDto {
    operatorId: string;
}

export interface CreateMultipleOperatorConfigurationsDto {
    configurations: CreateOperatorConfigurationDto[];
}

export interface OperatorLocationRequestDto {
    operatorId: string;
    locationId: string;
    agentId: string;
}

export interface CreateOperatorDto {
    id: string;
    naturalPerson: NaturalPersonDto;
    isActive: boolean;
    agentId: string;
}

export interface OperatorTerminalRequestDto {
    operatorId: string;
    terminalId: string;
    locationId: string;
    agentId: string;
}

export interface UpdateOperatorDto {
    id: string;
    naturalPerson: NaturalPersonDto;
}

export interface ActivateAgentSubServiceDto {
    id: string;
    agentId: string;
}

export interface LocationSubServiceDto {
    agentId: string;
    locationId: string;
    agentSubServiceId: string;
}

export interface CreateAgentSubServiceDto {
    agentId: string;
    subService: string;
}

export interface TerminalSubServiceDto {
    agentId: string;
    terminalId: string;
    agentSubServiceId: string;
}

export interface DeactivateAgentSubServiceDto {
    id: string;
    agentId: string;
}

export interface DeleteAgentSubServiceDto {
    id: string;
    agentId: string;
}

export interface CreateTerminalConfigurationDto extends ConfigurationCommonDto {
    terminalId: string;
}

export interface CreateMultipleTerminalConfigurationsDto {
    configurations: CreateTerminalConfigurationDto[];
}

export interface TerminalAgentServiceRequestDto {
    terminalId: string;
    agentServiceId: string;
    locationId: string;
}

export interface CreateTerminalDto {
    terminalName: string;
    terminalWuCode: string;
    terminalCertificateNumber: string;
    terminalCode: string;
    isActive: boolean;
    locationId: string;
}

export interface UpdateTerminalDto {
    id: string;
    terminalName: string;
    terminalWuCode: string;
    terminalCertificateNumber: string;
    terminalCode: string;
}

export interface AddressResponseDto extends Serializable {
    id: string;
    countryId: string;
    placeId: string;
    placeName: string;
    zipCode: string;
    streetName: string;
    streetNameTransformed: string;
    number: number;
    subNumber: number;
    letter: string;
    floor: number;
    apartmentNo: number;
    regionalCode: string;
    regionalSubCode: string;
    regionalPlusCode: string;
    geoLatitude: number;
    geoLongitude: number;
    geoAltitude: number;
    activated: boolean;
}

export interface WebResponseEntity<T> {
    result: T; problemResponseData?: ProblemResponseData|null;
}

export interface AgentAccountResponseDto extends Serializable {
    id: string;
    accountStatus: AccountStatus;
    currency: string;
    bban: string;
    accountBankInfo: AccountBankInfo;
    iban: string;
    swift: string;
    correspondentBank: string;
    foreignPaymentRecipient: string;
    canBeBlocked: boolean;
    purposeDescription: string;
    konto: string;
    accountType: AccountType;
    isDeactivated: boolean;
    createdAt: DateAsString;
    updatedAt: DateAsString;
    modifiedBy: string;
    agentId: string;
    version: number;
}

export interface WebListResponseEntity<T> {
    result: T[]; problemResponseData?: ProblemResponseData|null;
}

export interface WebResponseObject<T> extends WebResponseBase {
    result: T;
}

export interface AgentCategoryCommonDto {
    name: string;
}

export interface AgentCategoryDto {
    id: string;
    name: string;
}

export interface ConfigurationCommonDto {
    key: string;
    value: string;
}

export interface ConfigurationResponseDto {
    id: string;
    key: string;
    value: string;
    externalId: string;
}

export interface ContactPersonPhoneDto {
    phoneNumber: PhoneNumber;
    comment: string;
}

export interface CreateAddressDto extends AddressCommonDto {
}

export interface ContactPersonCommonDto {
    firstName: string;
    lastName: string;
    email: string;
    function: string;
    comment: string;
    phones: ContactPersonPhoneDto[];
}

export interface ContactPersonDto extends ContactPersonCommonDto {
    id: string;
    address: AddressResponseDto;
}

export interface UpdateAddressDto extends AddressCommonDto {
    id: string;
}

export interface DocumentHolderDto {
    name: string;
    surname: string;
    organizationUnit: string;
}

export interface ContractReminderDto {
    daysBeforeExpiration: number;
    type: ContractReminderType;
}

export interface AgentContractSubjectDto {
    name: string;
}

export interface AgentContractDto {
    id: string;
    contractName: string;
    signingDate: string;
    referenceNumber: string;
    agentSignatory: string;
    masterAgentSignatory: string;
    masterAgentSigningDate: string;
    masterAgentReferenceNumber: string;
    contractDuration: string;
    documentHolderName: DocumentHolderDto;
    contractTypeId: string;
    contractKindId: string;
    reminder: ContractReminderDto;
    contactPerson: ContactPersonDto;
    agentContractSubjects: AgentContractSubjectDto[];
    automaticContractRenewal: boolean;
}

export interface BusinessEntity {
    companyName: string;
    tradeName: string;
    typeOfLegalEntity: string;
    registrationNumber: string;
    taxNumber: string;
    registeredActivity: string;
    dateEstablished: DateAsString;
    registrationCountry: string;
    formOfOwnership: string;
    businessType: string;
}

export interface ContactDto extends Serializable {
    primaryPhoneNumber: PhoneNumber;
    secondaryPhoneNumber: PhoneNumber;
    notificationPhoneNumber: PhoneNumber;
    mobilePhoneNumber: string;
    workPhoneNumber: string;
    emailAddress: string;
    webAddress: string;
    contactDescription: string;
}

export interface AgentDto extends Serializable {
    id: string;
    isActive: boolean;
    businessEntity: BusinessEntityDto;
    addressId: string;
    address: AddressResponseDto;
    contact: ContactDto;
    partyId: string;
    version: number;
    statisticalGroup: AgentStatisticalGroupDto;
    category: AgentCategoryDto;
}

export interface BusinessEntityDto extends Serializable {
    companyName: string;
    tradeName: string;
    typeOfLegalEntity: string;
    registrationNumber: string;
    taxNumber: string;
    registeredActivity: string;
    dateEstablished: DateAsString;
    registrationCountry: string;
    formOfOwnership: string;
    businessType: string;
}

export interface AgentStatisticalGroupCommonDto {
    name: string;
}

export interface AgentStatisticalGroupDto {
    id: string;
    name: string;
}

export interface RegionalManagerDto {
    firstName: string;
    lastName: string;
}

export interface LocationDto extends Serializable {
    id: string;
    name: string;
    shortName: string;
    opened: boolean;
    isActive: boolean;
    address: AddressResponseDto;
    note: string;
    contact: ContactDto;
    agent: ShortAgentDto;
    externalData: LocationExternalDataDto;
    regionalManager: RegionalManagerDto;
    locationGroup: LocationGroupDto;
    subServices: AgentSubServiceDto[];
    contactPerson1: ContactPersonCommonDto;
    contactPerson2: ContactPersonCommonDto;
    version: number;
}

export interface LocationExternalDataDto {
    wuAccountId: string;
    bookKeepingId: string;
}

export interface LocationGroupDto {
    id: string;
    name: string;
    code: string;
    version: number;
}

export interface WorkingTimeDto {
    description: string;
    startTime: DateAsString;
    endTime: DateAsString;
}

export interface LocationWorkingDayCommonDto extends Serializable {
    id: string;
    dayOfWeek: DayOfWeek;
    dayKind: DayKindEnum;
    workingTimes: WorkingTimeDto[];
}

export interface NaturalPersonDto extends Serializable {
    firstName: string;
    lastName: string;
    middleName: string;
    birthdayDate: DateAsString;
    birthPlace: string;
    identificationNumber: string;
    birthCountry: string;
    citizenshipCountry: string;
}

export interface OperatorDto extends Serializable {
    id: string;
    naturalPerson: NaturalPersonDto;
    isActive: boolean;
    agent: ShortAgentDto;
    agentServices: ShortAgentSubServiceDto[];
    locations: ShortLocationDto[];
    terminals: ShortTerminalDto[];
    version: number;
}

export interface AgentSubServiceDto extends Serializable {
    id: string;
    isActive: boolean;
    subServiceCode: string;
    agent: ShortAgentDto;
    version: number;
}

export interface TerminalDto {
    id: string;
    terminalName: string;
    terminalWuCode: string;
    terminalCode: string;
    terminalCertificateNumber: string;
    isActive: boolean;
    location: ShortLocationDto;
    subServices: AgentSubServiceDto[];
    version: number;
}

export interface Serializable {
}

export interface AccountBankInfo {
    bankName: string;
    bankId: string;
    bic: string;
}

export interface ProblemResponseData extends Serializable {
    error: boolean;
    problems: ProblemBase[];
}

export interface WebResponseBase extends Serializable {
    problemResponseData: ProblemResponseData;
}

export interface PhoneNumber {
    countryCode: string;
    code: string;
    number: string;
}

export interface AddressCommonDto {
    countryId: string;
    placeId: string;
    placeName: string;
    zipCode: string;
    streetName: string;
    streetNameTransformed: string;
    number: number;
    subNumber: number;
    letter: string;
    floor: number;
    apartmentNo: number;
    regionalCode: string;
    regionalSubCode: string;
    regionalPlusCode: string;
    geoLatitude: number;
    geoLongitude: number;
    geoAltitude: number;
    activated: boolean;
}

export interface ShortAgentDto extends Serializable {
    id: string;
    isActive: boolean;
    businessEntity: BusinessEntityDto;
    version: number;
}

export interface ShortAgentSubServiceDto extends Serializable {
    id: string;
    name: string;
    isActive: boolean;
    version: number;
}

export interface ShortLocationDto extends Serializable {
    id: string;
    name: string;
    isActive: boolean;
    opened: boolean;
    version: number;
}

export interface ShortTerminalDto extends Serializable {
    id: string;
    terminalName: string;
    terminalWuCode: string;
    terminalCertificateNumber: string;
    isActive: boolean;
    version: number;
}

export interface ResponseEntity<T> {
    result: T;
    problemResponseData?: ProblemResponseData|null;
}

export interface ProblemBase extends Serializable {
    problemCode: number;
    applicationOrigin: string;
    exceptionCode: string;
    message: string;
    details: string;
    type: string;
}

export interface HttpEntity<T> {
    headers: { [index: string]: string[] };
    body: T;
}

export interface HttpClient<O> {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: O; }): RestResponse<R>;
}

export class RestApplicationClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /agent-network/agent-account-deactivation/create
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentAccountDeactivationRequestController.create
     */
    create$POST$agent_network_agentaccountdeactivation_create(createDeactivationRequestDto: CreateDeactivationRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent-account-deactivation/create`, data: createDeactivationRequestDto, options: options });
    }

    /**
     * HTTP GET /agent-network/agent-account-deactivation/hello
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentAccountDeactivationRequestController.hello
     */
    hello(options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/agent-account-deactivation/hello`, options: options });
    }

    /**
     * HTTP POST /agent-network/agent-account-deactivation/verification
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentAccountDeactivationRequestController.verificateDeactivation
     */
    verificateDeactivation(verificateAgentAccountDeactivationRequestDto: VerificateAgentAccountDeactivationRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent-account-deactivation/verification`, data: verificateAgentAccountDeactivationRequestDto, options: options });
    }

    /**
     * HTTP POST /agent-network/agent-account/create
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentAccountController.create
     */
    create$POST$agent_network_agentaccount_create(createAgentAccountDto: CreateAgentAccountDto, options?: O): RestResponse<WebResponseEntity<AgentAccountResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent-account/create`, data: createAgentAccountDto, options: options });
    }

    /**
     * HTTP GET /agent-network/agent-account/find-for-agent
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentAccountController.findForAgent
     */
    findForAgent(queryParams: { agentId: string; }, options?: O): RestResponse<WebListResponseEntity<AgentAccountResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/agent-account/find-for-agent`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/agent-account/get
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentAccountController.get
     */
    get(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<AgentAccountResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/agent-account/get`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/agent-account/update
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentAccountController.update
     */
    update$POST$agent_network_agentaccount_update(updateAgentAccountDto: UpdateAgentAccountDto, options?: O): RestResponse<WebResponseEntity<AgentAccountResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent-account/update`, data: updateAgentAccountDto, options: options });
    }

    /**
     * HTTP POST /agent-network/agent-category/create
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentCategoryController.create
     */
    create$POST$agent_network_agentcategory_create(createAgentCategoryDto: CreateAgentCategoryDto, options?: O): RestResponse<WebResponseObject<AgentCategoryDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent-category/create`, data: createAgentCategoryDto, options: options });
    }

    /**
     * HTTP GET /agent-network/agent-category/find-all
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentCategoryController.findAll
     */
    findAll$GET$agent_network_agentcategory_findall(options?: O): RestResponse<WebListResponseEntity<AgentCategoryDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/agent-category/find-all`, options: options });
    }

    /**
     * HTTP GET /agent-network/agent-category/find-by-id
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentCategoryController.findById
     */
    findById$GET$agent_network_agentcategory_findbyid(queryParams: { id: string; }, options?: O): RestResponse<WebResponseObject<AgentCategoryDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/agent-category/find-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/agent-category/update
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentCategoryController.update
     */
    update$POST$agent_network_agentcategory_update(updateAgentCategoryDto: UpdateAgentCategoryDto, options?: O): RestResponse<WebResponseObject<AgentCategoryDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent-category/update`, data: updateAgentCategoryDto, options: options });
    }

    /**
     * HTTP POST /agent-network/agent-configuration/create
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentConfigurationController.create
     */
    create$POST$agent_network_agentconfiguration_create(createDto: CreateAgentConfigurationDto, options?: O): RestResponse<WebResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent-configuration/create`, data: createDto, options: options });
    }

    /**
     * HTTP POST /agent-network/agent-configuration/create-multiple
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentConfigurationController.createMultiple
     */
    createMultiple$POST$agent_network_agentconfiguration_createmultiple(createMultipleDto: CreateMultipleAgentConfigurationsDto, options?: O): RestResponse<WebListResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent-configuration/create-multiple`, data: createMultipleDto, options: options });
    }

    /**
     * HTTP GET /agent-network/agent-configuration/find-all
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentConfigurationController.findAll
     */
    findAll$GET$agent_network_agentconfiguration_findall(options?: O): RestResponse<WebListResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/agent-configuration/find-all`, options: options });
    }

    /**
     * HTTP GET /agent-network/agent-configuration/find-by-agent
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentConfigurationController.findByAgent
     */
    findByAgent(queryParams: { agentId: string; }, options?: O): RestResponse<WebListResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/agent-configuration/find-by-agent`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/agent-configuration/find-by-id
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentConfigurationController.findById
     */
    findById$GET$agent_network_agentconfiguration_findbyid(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/agent-configuration/find-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/agent-configuration/update
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentConfigurationController.update
     */
    update$POST$agent_network_agentconfiguration_update(updateDto: UpdateConfigurationDto, options?: O): RestResponse<WebResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent-configuration/update`, data: updateDto, options: options });
    }

    /**
     * HTTP POST /agent-network/agent-contact/create
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentContactController.create
     */
    create$POST$agent_network_agentcontact_create(dto: CreateAgentContactPersonDto, options?: O): RestResponse<WebResponseObject<ContactPersonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent-contact/create`, data: dto, options: options });
    }

    /**
     * HTTP POST /agent-network/agent-contact/delete
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentContactController.delete
     */
    delete(deleteAgentContactDto: DeleteAgentContactDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent-contact/delete`, data: deleteAgentContactDto, options: options });
    }

    /**
     * HTTP GET /agent-network/agent-contact/find-for-agent
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentContactController.findContactsForAgent
     */
    findContactsForAgent(queryParams: { agentId: string; }, options?: O): RestResponse<WebListResponseEntity<ContactPersonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/agent-contact/find-for-agent`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/agent-contact/update
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentContactController.update
     */
    update$POST$agent_network_agentcontact_update(dto: UpdateAgentContactPersonDto, options?: O): RestResponse<WebResponseObject<ContactPersonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent-contact/update`, data: dto, options: options });
    }

    /**
     * HTTP POST /agent-network/agent-contract/add-new-contract
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentContractController.addNewContract
     */
    addNewContract(agentContractDto: CreateAgentContractDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent-contract/add-new-contract`, data: agentContractDto, options: options });
    }

    /**
     * HTTP POST /agent-network/agent-contract/add-new-contract-kind
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentContractController.addNewContractKind
     */
    addNewContractKind(agentContractKindDto: AgentContractKindDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent-contract/add-new-contract-kind`, data: agentContractKindDto, options: options });
    }

    /**
     * HTTP POST /agent-network/agent-contract/add-new-contract-type
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentContractController.addNewContractType
     */
    addNewContractType(agentContractTypeDto: AgentContractTypeDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent-contract/add-new-contract-type`, data: agentContractTypeDto, options: options });
    }

    /**
     * HTTP GET /agent-network/agent-contract/get-by-id
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentContractController.getContractById
     */
    getContractById(queryParams: { id: string; }, options?: O): RestResponse<WebResponseObject<AgentContractDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/agent-contract/get-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/agent-contract/update
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentContractController.updateContract
     */
    updateContract(agentContractDto: CreateAgentContractDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent-contract/update`, data: agentContractDto, options: options });
    }

    /**
     * HTTP POST /agent-network/agent-statistical-group/create
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentStatisticalGroupController.create
     */
    create$POST$agent_network_agentstatisticalgroup_create(createAgentStatisticalGroupDto: CreateAgentStatisticalGroupDto, options?: O): RestResponse<WebResponseObject<AgentStatisticalGroupDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent-statistical-group/create`, data: createAgentStatisticalGroupDto, options: options });
    }

    /**
     * HTTP GET /agent-network/agent-statistical-group/find-all
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentStatisticalGroupController.findAll
     */
    findAll$GET$agent_network_agentstatisticalgroup_findall(options?: O): RestResponse<WebListResponseEntity<AgentStatisticalGroupDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/agent-statistical-group/find-all`, options: options });
    }

    /**
     * HTTP GET /agent-network/agent-statistical-group/find-by-id
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentStatisticalGroupController.findById
     */
    findById$GET$agent_network_agentstatisticalgroup_findbyid(queryParams: { id: string; }, options?: O): RestResponse<WebResponseObject<AgentStatisticalGroupDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/agent-statistical-group/find-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/agent-statistical-group/update
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentStatisticalGroupController.update
     */
    update$POST$agent_network_agentstatisticalgroup_update(updateAgentStatisticalGroupDto: UpdateAgentStatisticalGroupDto, options?: O): RestResponse<WebResponseObject<AgentStatisticalGroupDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent-statistical-group/update`, data: updateAgentStatisticalGroupDto, options: options });
    }

    /**
     * HTTP POST /agent-network/agent/activate
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentController.activateAgent
     */
    activateAgent(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent/activate`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/agent/create
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentController.createAgent
     */
    createAgent$POST$agent_network_agent_create(createAgentDto: CreateAgentDto, options?: O): RestResponse<WebResponseEntity<AgentDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent/create`, data: createAgentDto, options: options });
    }

    /**
     * HTTP POST /agent-network/agent/create-from-party
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentController.createAgent
     */
    createAgent$POST$agent_network_agent_createfromparty(createAgentDto: CreateAgentFromPartyDto, options?: O): RestResponse<WebResponseEntity<AgentDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent/create-from-party`, data: createAgentDto, options: options });
    }

    /**
     * HTTP POST /agent-network/agent/deactivate
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentController.deactivateAgent
     */
    deactivateAgent(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent/deactivate`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/agent/delete
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentController.deleteAgent
     */
    deleteAgent(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent/delete`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/agent/find
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentController.findAgentsByName
     */
    findAgentsByName(queryParams: { name: string; }, options?: O): RestResponse<WebListResponseEntity<AgentDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/agent/find`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/agent/get
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentController.getAgent
     */
    getAgent(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<AgentDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/agent/get`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/agent/get-all
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentController.getAllAgents
     */
    getAllAgents(options?: O): RestResponse<WebListResponseEntity<AgentDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/agent/get-all`, options: options });
    }

    /**
     * HTTP POST /agent-network/agent/update
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.AgentController.updateAgent
     */
    updateAgent(updateAgentDto: UpdateAgentDto, options?: O): RestResponse<WebResponseEntity<AgentDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/agent/update`, data: updateAgentDto, options: options });
    }

    /**
     * HTTP GET /agent-network/geo-data/address/find
     * Java method: com.europoint.agentnetwork.webapi.controllers.geodata.AddressController.findAddress
     */
    findAddress(options?: O): RestResponse<AddressResponseDto> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/geo-data/address/find`, options: options });
    }

    /**
     * HTTP GET /agent-network/geo-data/address/find-all
     * Java method: com.europoint.agentnetwork.webapi.controllers.geodata.AddressController.findAllAddress
     */
    findAllAddress(options?: O): RestResponse<AddressResponseDto[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/geo-data/address/find-all`, options: options });
    }

    /**
     * HTTP POST /agent-network/location-configuration/create
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationConfigurationController.create
     */
    create$POST$agent_network_locationconfiguration_create(createDto: CreateLocationConfigurationDto, options?: O): RestResponse<WebResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location-configuration/create`, data: createDto, options: options });
    }

    /**
     * HTTP POST /agent-network/location-configuration/create-multiple
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationConfigurationController.createMultiple
     */
    createMultiple$POST$agent_network_locationconfiguration_createmultiple(createMultipleDto: CreateMultipleLocationConfigurationsDto, options?: O): RestResponse<WebListResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location-configuration/create-multiple`, data: createMultipleDto, options: options });
    }

    /**
     * HTTP GET /agent-network/location-configuration/find-all
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationConfigurationController.findAll
     */
    findAll$GET$agent_network_locationconfiguration_findall(options?: O): RestResponse<WebListResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/location-configuration/find-all`, options: options });
    }

    /**
     * HTTP GET /agent-network/location-configuration/find-by-id
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationConfigurationController.findById
     */
    findById$GET$agent_network_locationconfiguration_findbyid(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/location-configuration/find-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/location-configuration/find-by-location
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationConfigurationController.findByLocation
     */
    findByLocation(queryParams: { locationId: string; }, options?: O): RestResponse<WebListResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/location-configuration/find-by-location`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/location-configuration/update
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationConfigurationController.update
     */
    update$POST$agent_network_locationconfiguration_update(updateDto: UpdateConfigurationDto, options?: O): RestResponse<WebResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location-configuration/update`, data: updateDto, options: options });
    }

    /**
     * HTTP POST /agent-network/location-group/create
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationGroupController.createLocationGroup
     */
    createLocationGroup(locationGroupRequestDto: CreateLocationGroupDto, options?: O): RestResponse<WebResponseEntity<LocationGroupDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location-group/create`, data: locationGroupRequestDto, options: options });
    }

    /**
     * HTTP POST /agent-network/location-group/delete
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationGroupController.deleteLocationGroup
     */
    deleteLocationGroup(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location-group/delete`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/location-group/get
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationGroupController.getLocationGroup
     */
    getLocationGroup(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<LocationGroupDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/location-group/get`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/location-group/get-all
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationGroupController.getAllLocationGroup
     */
    getAllLocationGroup(options?: O): RestResponse<WebListResponseEntity<LocationGroupDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/location-group/get-all`, options: options });
    }

    /**
     * HTTP POST /agent-network/location-group/update
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationGroupController.updateLocationGroup
     */
    updateLocationGroup(locationGroupRequestDto: UpdateLocationGroupDto, options?: O): RestResponse<WebResponseEntity<LocationGroupDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location-group/update`, data: locationGroupRequestDto, options: options });
    }

    /**
     * HTTP POST /agent-network/location/activate
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.activateLocation
     */
    activateLocation(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location/activate`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/location/add-service
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.addAgentService
     */
    addAgentService(locationAgentServiceDto: LocationAgentServiceDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location/add-service`, data: locationAgentServiceDto, options: options });
    }

    /**
     * HTTP POST /agent-network/location/add-to-group
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.addToGroup
     */
    addToGroup(queryParams: { locationId: string; groupId: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location/add-to-group`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/location/close
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.setClosed
     */
    setClosed(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location/close`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/location/create
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.createLocation
     */
    createLocation(locationRequest: CreateLocationDto, options?: O): RestResponse<WebResponseEntity<LocationDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location/create`, data: locationRequest, options: options });
    }

    /**
     * HTTP POST /agent-network/location/deactivate
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.deactivateLocation
     */
    deactivateLocation(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location/deactivate`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/location/deactivate-by-agent
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.deactivateLocationsByAgent
     */
    deactivateLocationsByAgent(queryParams: { agentId: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location/deactivate-by-agent`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/location/delete
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.deleteLocation
     */
    deleteLocation(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location/delete`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/location/get
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.getLocation
     */
    getLocation(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<LocationDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/location/get`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/location/get-active-by-agent
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.getAllActiveLocationsByAgent
     */
    getAllActiveLocationsByAgent(queryParams: { agentId: string; }, options?: O): RestResponse<WebListResponseEntity<LocationDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/location/get-active-by-agent`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/location/get-all
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.getAllLocations
     */
    getAllLocations(options?: O): RestResponse<WebListResponseEntity<LocationDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/location/get-all`, options: options });
    }

    /**
     * HTTP GET /agent-network/location/get-by-agent
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.getAllLocationsByAgent
     */
    getAllLocationsByAgent(queryParams: { agentId: string; }, options?: O): RestResponse<WebListResponseEntity<LocationDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/location/get-by-agent`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/location/get-by-name
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.findLocationsByName
     */
    findLocationsByName(queryParams: { name: string; }, options?: O): RestResponse<WebListResponseEntity<LocationDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/location/get-by-name`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/location/open
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.setOpened
     */
    setOpened(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location/open`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/location/remove-all-services
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.removeAllServicesFromLocation
     */
    removeAllServicesFromLocation(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location/remove-all-services`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/location/remove-from-group
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.removeFromGroup
     */
    removeFromGroup(queryParams: { locationId: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location/remove-from-group`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/location/remove-service
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.removeAgentService
     */
    removeAgentService(locationAgentServiceDto: LocationAgentServiceDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location/remove-service`, data: locationAgentServiceDto, options: options });
    }

    /**
     * HTTP POST /agent-network/location/update
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.updateLocation
     */
    updateLocation(updateLocationDto: UpdateLocationDto, options?: O): RestResponse<WebResponseEntity<LocationDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location/update`, data: updateLocationDto, options: options });
    }

    /**
     * HTTP POST /agent-network/location/update-external-data
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationController.updatedExternalData
     */
    updatedExternalData(externalDataDto: UpdateLocationExternalDataDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/location/update-external-data`, data: externalDataDto, options: options });
    }

    /**
     * HTTP POST /agent-network/operator-configuration/create
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorConfigurationController.create
     */
    create$POST$agent_network_operatorconfiguration_create(createDto: CreateOperatorConfigurationDto, options?: O): RestResponse<WebResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/operator-configuration/create`, data: createDto, options: options });
    }

    /**
     * HTTP POST /agent-network/operator-configuration/create-multiple
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorConfigurationController.createMultiple
     */
    createMultiple$POST$agent_network_operatorconfiguration_createmultiple(createMultipleDto: CreateMultipleOperatorConfigurationsDto, options?: O): RestResponse<WebListResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/operator-configuration/create-multiple`, data: createMultipleDto, options: options });
    }

    /**
     * HTTP GET /agent-network/operator-configuration/find-all
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorConfigurationController.findAll
     */
    findAll$GET$agent_network_operatorconfiguration_findall(options?: O): RestResponse<WebListResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/operator-configuration/find-all`, options: options });
    }

    /**
     * HTTP GET /agent-network/operator-configuration/find-by-id
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorConfigurationController.findById
     */
    findById$GET$agent_network_operatorconfiguration_findbyid(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/operator-configuration/find-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/operator-configuration/find-by-operator
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorConfigurationController.findByOperator
     */
    findByOperator(queryParams: { operatorId: string; }, options?: O): RestResponse<WebListResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/operator-configuration/find-by-operator`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/operator-configuration/update
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorConfigurationController.update
     */
    update$POST$agent_network_operatorconfiguration_update(updateDto: UpdateConfigurationDto, options?: O): RestResponse<WebResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/operator-configuration/update`, data: updateDto, options: options });
    }

    /**
     * HTTP POST /agent-network/operator/activate
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorController.activateOperator
     */
    activateOperator(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/operator/activate`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/operator/add-location
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorController.addLocationToOperator
     */
    addLocationToOperator(operatorLocationDto: OperatorLocationRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/operator/add-location`, data: operatorLocationDto, options: options });
    }

    /**
     * HTTP POST /agent-network/operator/add-terminal
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorController.addTerminalToOperator
     */
    addTerminalToOperator(operatorTerminalDto: OperatorTerminalRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/operator/add-terminal`, data: operatorTerminalDto, options: options });
    }

    /**
     * HTTP POST /agent-network/operator/create
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorController.addOperator
     */
    addOperator(createOperatorDto: CreateOperatorDto, options?: O): RestResponse<WebResponseEntity<OperatorDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/operator/create`, data: createOperatorDto, options: options });
    }

    /**
     * HTTP POST /agent-network/operator/deactivate
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorController.deactivateOperator
     */
    deactivateOperator(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/operator/deactivate`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/operator/deactivate-by-agent
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorController.deactivateOperatorsByAgent
     */
    deactivateOperatorsByAgent(queryParams: { agentId: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/operator/deactivate-by-agent`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/operator/delete
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorController.deleteOperator
     */
    deleteOperator(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/operator/delete`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/operator/get
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorController.getOperator
     */
    getOperator(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<OperatorDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/operator/get`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/operator/get-active-by-agent
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorController.getAllActiveOperatorsByAgent
     */
    getAllActiveOperatorsByAgent(queryParams: { agentId: string; }, options?: O): RestResponse<WebListResponseEntity<OperatorDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/operator/get-active-by-agent`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/operator/get-all
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorController.getAllOperators
     */
    getAllOperators(options?: O): RestResponse<WebListResponseEntity<OperatorDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/operator/get-all`, options: options });
    }

    /**
     * HTTP GET /agent-network/operator/get-all-by-page
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorController.getAllOperatorsByPage
     */
    getAllOperatorsByPage(queryParams?: { page?: number; size?: number; }, options?: O): RestResponse<WebListResponseEntity<OperatorDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/operator/get-all-by-page`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/operator/get-by-agent
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorController.getAllOperatorsByAgent
     */
    getAllOperatorsByAgent(queryParams: { agentId: string; }, options?: O): RestResponse<WebListResponseEntity<OperatorDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/operator/get-by-agent`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/operator/get-by-name
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorController.getOperatorsByFullName
     */
    getOperatorsByFullName(queryParams: { firstName: string; lastName: string; }, options?: O): RestResponse<WebListResponseEntity<OperatorDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/operator/get-by-name`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/operator/remove-all-locations
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorController.removeAllLocationsFromOperator
     */
    removeAllLocationsFromOperator(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/operator/remove-all-locations`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/operator/remove-all-terminals
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorController.removeAllTerminalsFromOperator
     */
    removeAllTerminalsFromOperator(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/operator/remove-all-terminals`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/operator/remove-location
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorController.removeLocationFromOperator
     */
    removeLocationFromOperator(operatorLocationDto: OperatorLocationRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/operator/remove-location`, data: operatorLocationDto, options: options });
    }

    /**
     * HTTP POST /agent-network/operator/remove-terminal
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorController.removeTerminalFromOperator
     */
    removeTerminalFromOperator(operatorTerminalDto: OperatorTerminalRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/operator/remove-terminal`, data: operatorTerminalDto, options: options });
    }

    /**
     * HTTP POST /agent-network/operator/update
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.OperatorController.updateOperator
     */
    updateOperator(updateOperatorDto: UpdateOperatorDto, options?: O): RestResponse<WebResponseEntity<OperatorDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/operator/update`, data: updateOperatorDto, options: options });
    }

    /**
     * HTTP POST /agent-network/service/activate-sub-service/agent
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.PlatformSubServiceManagementController.activateSubService
     */
    activateSubService(dto: ActivateAgentSubServiceDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/service/activate-sub-service/agent`, data: dto, options: options });
    }

    /**
     * HTTP POST /agent-network/service/add-sub-service/agent
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.PlatformSubServiceManagementController.addService
     */
    addService(addAgentServiceDto: CreateAgentSubServiceDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/service/add-sub-service/agent`, data: addAgentServiceDto, options: options });
    }

    /**
     * HTTP POST /agent-network/service/add-sub-service/location
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.PlatformSubServiceManagementController.addLocationService
     */
    addLocationService(locationSubServiceDto: LocationSubServiceDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/service/add-sub-service/location`, data: locationSubServiceDto, options: options });
    }

    /**
     * HTTP POST /agent-network/service/add-sub-service/terminal
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.PlatformSubServiceManagementController.addTerminalSubService
     */
    addTerminalSubService(terminalSubServiceDto: TerminalSubServiceDto, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/service/add-sub-service/terminal`, data: terminalSubServiceDto, options: options });
    }

    /**
     * HTTP POST /agent-network/service/deactivate-sub-service/agent
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.PlatformSubServiceManagementController.deactivateSubService
     */
    deactivateSubService(dto: DeactivateAgentSubServiceDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/service/deactivate-sub-service/agent`, data: dto, options: options });
    }

    /**
     * HTTP POST /agent-network/service/delete-sub-service/agent
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.PlatformSubServiceManagementController.deleteSubService
     */
    deleteSubService(dto: DeleteAgentSubServiceDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/service/delete-sub-service/agent`, data: dto, options: options });
    }

    /**
     * HTTP GET /agent-network/service/get-all-master-agent-sub-services
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.PlatformSubServiceManagementController.getAllMasterAgentSubService
     */
    getAllMasterAgentSubService(options?: O): RestResponse<WebListResponseEntity<string>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/service/get-all-master-agent-sub-services`, options: options });
    }

    /**
     * HTTP GET /agent-network/service/get-master-agent-services
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.PlatformSubServiceManagementController.getMasterAgentServices
     */
    getMasterAgentServices(options?: O): RestResponse<WebListResponseEntity<string>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/service/get-master-agent-services`, options: options });
    }

    /**
     * HTTP GET /agent-network/service/get-master-agent-sub-services
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.PlatformSubServiceManagementController.getMasterAgentSubService
     */
    getMasterAgentSubService(queryParams: { service: string; }, options?: O): RestResponse<WebListResponseEntity<string>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/service/get-master-agent-sub-services`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/service/get-sub-services-for-agent
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.PlatformSubServiceManagementController.findAgentSubServicesByAgentId
     */
    findAgentSubServicesByAgentId(queryParams: { agentId: string; }, options?: O): RestResponse<WebListResponseEntity<AgentSubServiceDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/service/get-sub-services-for-agent`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/service/remove-sub-service/terminal
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.PlatformSubServiceManagementController.removeTerminalSubService
     */
    removeTerminalSubService(terminalSubServiceDto: TerminalSubServiceDto, options?: O): RestResponse<WebStringResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/service/remove-sub-service/terminal`, data: terminalSubServiceDto, options: options });
    }

    /**
     * HTTP POST /agent-network/terminal-configuration/create
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalConfigurationController.create
     */
    create$POST$agent_network_terminalconfiguration_create(createDto: CreateTerminalConfigurationDto, options?: O): RestResponse<WebResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/terminal-configuration/create`, data: createDto, options: options });
    }

    /**
     * HTTP POST /agent-network/terminal-configuration/create-multiple
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalConfigurationController.createMultiple
     */
    createMultiple$POST$agent_network_terminalconfiguration_createmultiple(createMultipleDto: CreateMultipleTerminalConfigurationsDto, options?: O): RestResponse<WebListResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/terminal-configuration/create-multiple`, data: createMultipleDto, options: options });
    }

    /**
     * HTTP GET /agent-network/terminal-configuration/find-all
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalConfigurationController.findAll
     */
    findAll$GET$agent_network_terminalconfiguration_findall(options?: O): RestResponse<WebListResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/terminal-configuration/find-all`, options: options });
    }

    /**
     * HTTP GET /agent-network/terminal-configuration/find-by-id
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalConfigurationController.findById
     */
    findById$GET$agent_network_terminalconfiguration_findbyid(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/terminal-configuration/find-by-id`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/terminal-configuration/find-by-terminal
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalConfigurationController.findByTerminal
     */
    findByTerminal(queryParams: { terminalId: string; }, options?: O): RestResponse<WebListResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/terminal-configuration/find-by-terminal`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/terminal-configuration/update
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalConfigurationController.update
     */
    update$POST$agent_network_terminalconfiguration_update(updateDto: UpdateConfigurationDto, options?: O): RestResponse<WebResponseEntity<ConfigurationResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/terminal-configuration/update`, data: updateDto, options: options });
    }

    /**
     * HTTP POST /agent-network/terminal/activate
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalController.activateTerminal
     */
    activateTerminal(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/terminal/activate`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/terminal/add-service
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalController.addServiceToTerminal
     */
    addServiceToTerminal(terminalAgentServiceRequestDto: TerminalAgentServiceRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/terminal/add-service`, data: terminalAgentServiceRequestDto, options: options });
    }

    /**
     * HTTP POST /agent-network/terminal/create
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalController.addTerminal
     */
    addTerminal(createTerminalDto: CreateTerminalDto, options?: O): RestResponse<WebResponseEntity<TerminalDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/terminal/create`, data: createTerminalDto, options: options });
    }

    /**
     * HTTP POST /agent-network/terminal/deactivate
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalController.deactivateTerminal
     */
    deactivateTerminal(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/terminal/deactivate`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/terminal/deactivate-by-agent
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalController.deactivateTerminalsByAgent
     */
    deactivateTerminalsByAgent(queryParams: { agentId: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/terminal/deactivate-by-agent`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/terminal/deactivate-by-location
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalController.deactivateTerminalsByLocation
     */
    deactivateTerminalsByLocation(queryParams: { locationId: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/terminal/deactivate-by-location`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/terminal/delete
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalController.deleteTerminal
     */
    deleteTerminal(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/terminal/delete`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/terminal/get
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalController.getTerminal
     */
    getTerminal(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<TerminalDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/terminal/get`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/terminal/get-active-by-location
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalController.getIsActiveTerminalByLocation
     */
    getIsActiveTerminalByLocation(queryParams: { locationId: string; }, options?: O): RestResponse<WebListResponseEntity<TerminalDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/terminal/get-active-by-location`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/terminal/get-all
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalController.getAllTerminals
     */
    getAllTerminals(options?: O): RestResponse<WebListResponseEntity<TerminalDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/terminal/get-all`, options: options });
    }

    /**
     * HTTP GET /agent-network/terminal/get-by-location
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalController.getTerminalByLocation
     */
    getTerminalByLocation(queryParams: { locationId: string; }, options?: O): RestResponse<WebListResponseEntity<TerminalDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/terminal/get-by-location`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/terminal/remove-all-services
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalController.removeAllServicesFromTerminal
     */
    removeAllServicesFromTerminal(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/terminal/remove-all-services`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/terminal/remove-service
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalController.removeServiceFromTerminal
     */
    removeServiceFromTerminal(terminalAgentServiceRequestDto: TerminalAgentServiceRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/terminal/remove-service`, data: terminalAgentServiceRequestDto, options: options });
    }

    /**
     * HTTP POST /agent-network/terminal/update
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.TerminalController.updateTerminal
     */
    updateTerminal(updateTerminalDto: UpdateTerminalDto, options?: O): RestResponse<WebResponseEntity<TerminalDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/terminal/update`, data: updateTerminalDto, options: options });
    }

    /**
     * HTTP POST /agent-network/working-day/create
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationWorkingDayController.addLocationWorkingDay
     */
    addLocationWorkingDay(locationWorkingDayRequest: CreateLocationWorkingDayDto, options?: O): RestResponse<WebResponseEntity<LocationWorkingDayCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/working-day/create`, data: locationWorkingDayRequest, options: options });
    }

    /**
     * HTTP POST /agent-network/working-day/delete
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationWorkingDayController.deleteLocationWorkingDay
     */
    deleteLocationWorkingDay(queryParams: { id: string; }, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/working-day/delete`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/working-day/get
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationWorkingDayController.getLocationWorkingDay
     */
    getLocationWorkingDay(queryParams: { id: string; }, options?: O): RestResponse<WebResponseEntity<LocationWorkingDayCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/working-day/get`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /agent-network/working-day/get-by-location
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationWorkingDayController.getLocationWorkingDaysByLocation
     */
    getLocationWorkingDaysByLocation(queryParams: { locationId: string; }, options?: O): RestResponse<WebListResponseEntity<LocationWorkingDayCommonDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`agent-network/working-day/get-by-location`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /agent-network/working-day/set-opening-hours
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationWorkingDayController.setLocationOpeningHours
     */
    setLocationOpeningHours(locationAddDayRequest: LocationAddDayDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/working-day/set-opening-hours`, data: locationAddDayRequest, options: options });
    }

    /**
     * HTTP POST /agent-network/working-day/update
     * Java method: com.europoint.agentnetwork.webapi.controllers.agents.LocationWorkingDayController.updateLocationWorkingDay
     */
    updateLocationWorkingDay(updateLocationWorkingDayDto: UpdateLocationWorkingDayDto, options?: O): RestResponse<WebResponseEntity<LocationWorkingDayCommonDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`agent-network/working-day/update`, data: updateLocationWorkingDayDto, options: options });
    }
}

export type RestResponse<R> = Promise<Axios.GenericAxiosResponse<R>>;

export type DateAsString = string;

export const enum AccountStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    CLOSED = "CLOSED",
}

export const enum AccountType {
    TRANSACTIONAL = "TRANSACTIONAL",
    PURPOSE = "PURPOSE",
    SPECIAL = "SPECIAL",
    REGULAR = "REGULAR",
    SAVINGS = "SAVINGS",
    CREDIT = "CREDIT",
}

/**
 * Values:
 * - `CONTINUE`
 * - `SWITCHING_PROTOCOLS`
 * - `PROCESSING`
 * - `CHECKPOINT`
 * - `OK`
 * - `CREATED`
 * - `ACCEPTED`
 * - `NON_AUTHORITATIVE_INFORMATION`
 * - `NO_CONTENT`
 * - `RESET_CONTENT`
 * - `PARTIAL_CONTENT`
 * - `MULTI_STATUS`
 * - `ALREADY_REPORTED`
 * - `IM_USED`
 * - `MULTIPLE_CHOICES`
 * - `MOVED_PERMANENTLY`
 * - `FOUND`
 * - `MOVED_TEMPORARILY` - @deprecated
 * - `SEE_OTHER`
 * - `NOT_MODIFIED`
 * - `USE_PROXY` - @deprecated
 * - `TEMPORARY_REDIRECT`
 * - `PERMANENT_REDIRECT`
 * - `BAD_REQUEST`
 * - `UNAUTHORIZED`
 * - `PAYMENT_REQUIRED`
 * - `FORBIDDEN`
 * - `NOT_FOUND`
 * - `METHOD_NOT_ALLOWED`
 * - `NOT_ACCEPTABLE`
 * - `PROXY_AUTHENTICATION_REQUIRED`
 * - `REQUEST_TIMEOUT`
 * - `CONFLICT`
 * - `GONE`
 * - `LENGTH_REQUIRED`
 * - `PRECONDITION_FAILED`
 * - `PAYLOAD_TOO_LARGE`
 * - `REQUEST_ENTITY_TOO_LARGE` - @deprecated
 * - `URI_TOO_LONG`
 * - `REQUEST_URI_TOO_LONG` - @deprecated
 * - `UNSUPPORTED_MEDIA_TYPE`
 * - `REQUESTED_RANGE_NOT_SATISFIABLE`
 * - `EXPECTATION_FAILED`
 * - `I_AM_A_TEAPOT`
 * - `INSUFFICIENT_SPACE_ON_RESOURCE` - @deprecated
 * - `METHOD_FAILURE` - @deprecated
 * - `DESTINATION_LOCKED` - @deprecated
 * - `UNPROCESSABLE_ENTITY`
 * - `LOCKED`
 * - `FAILED_DEPENDENCY`
 * - `TOO_EARLY`
 * - `UPGRADE_REQUIRED`
 * - `PRECONDITION_REQUIRED`
 * - `TOO_MANY_REQUESTS`
 * - `REQUEST_HEADER_FIELDS_TOO_LARGE`
 * - `UNAVAILABLE_FOR_LEGAL_REASONS`
 * - `INTERNAL_SERVER_ERROR`
 * - `NOT_IMPLEMENTED`
 * - `BAD_GATEWAY`
 * - `SERVICE_UNAVAILABLE`
 * - `GATEWAY_TIMEOUT`
 * - `HTTP_VERSION_NOT_SUPPORTED`
 * - `VARIANT_ALSO_NEGOTIATES`
 * - `INSUFFICIENT_STORAGE`
 * - `LOOP_DETECTED`
 * - `BANDWIDTH_LIMIT_EXCEEDED`
 * - `NOT_EXTENDED`
 * - `NETWORK_AUTHENTICATION_REQUIRED`
 */
export const enum HttpStatus {
    CONTINUE = "CONTINUE",
    SWITCHING_PROTOCOLS = "SWITCHING_PROTOCOLS",
    PROCESSING = "PROCESSING",
    CHECKPOINT = "CHECKPOINT",
    OK = "OK",
    CREATED = "CREATED",
    ACCEPTED = "ACCEPTED",
    NON_AUTHORITATIVE_INFORMATION = "NON_AUTHORITATIVE_INFORMATION",
    NO_CONTENT = "NO_CONTENT",
    RESET_CONTENT = "RESET_CONTENT",
    PARTIAL_CONTENT = "PARTIAL_CONTENT",
    MULTI_STATUS = "MULTI_STATUS",
    ALREADY_REPORTED = "ALREADY_REPORTED",
    IM_USED = "IM_USED",
    MULTIPLE_CHOICES = "MULTIPLE_CHOICES",
    MOVED_PERMANENTLY = "MOVED_PERMANENTLY",
    FOUND = "FOUND",
    /**
     * @deprecated
     */
    MOVED_TEMPORARILY = "MOVED_TEMPORARILY",
    SEE_OTHER = "SEE_OTHER",
    NOT_MODIFIED = "NOT_MODIFIED",
    /**
     * @deprecated
     */
    USE_PROXY = "USE_PROXY",
    TEMPORARY_REDIRECT = "TEMPORARY_REDIRECT",
    PERMANENT_REDIRECT = "PERMANENT_REDIRECT",
    BAD_REQUEST = "BAD_REQUEST",
    UNAUTHORIZED = "UNAUTHORIZED",
    PAYMENT_REQUIRED = "PAYMENT_REQUIRED",
    FORBIDDEN = "FORBIDDEN",
    NOT_FOUND = "NOT_FOUND",
    METHOD_NOT_ALLOWED = "METHOD_NOT_ALLOWED",
    NOT_ACCEPTABLE = "NOT_ACCEPTABLE",
    PROXY_AUTHENTICATION_REQUIRED = "PROXY_AUTHENTICATION_REQUIRED",
    REQUEST_TIMEOUT = "REQUEST_TIMEOUT",
    CONFLICT = "CONFLICT",
    GONE = "GONE",
    LENGTH_REQUIRED = "LENGTH_REQUIRED",
    PRECONDITION_FAILED = "PRECONDITION_FAILED",
    PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE",
    /**
     * @deprecated
     */
    REQUEST_ENTITY_TOO_LARGE = "REQUEST_ENTITY_TOO_LARGE",
    URI_TOO_LONG = "URI_TOO_LONG",
    /**
     * @deprecated
     */
    REQUEST_URI_TOO_LONG = "REQUEST_URI_TOO_LONG",
    UNSUPPORTED_MEDIA_TYPE = "UNSUPPORTED_MEDIA_TYPE",
    REQUESTED_RANGE_NOT_SATISFIABLE = "REQUESTED_RANGE_NOT_SATISFIABLE",
    EXPECTATION_FAILED = "EXPECTATION_FAILED",
    I_AM_A_TEAPOT = "I_AM_A_TEAPOT",
    /**
     * @deprecated
     */
    INSUFFICIENT_SPACE_ON_RESOURCE = "INSUFFICIENT_SPACE_ON_RESOURCE",
    /**
     * @deprecated
     */
    METHOD_FAILURE = "METHOD_FAILURE",
    /**
     * @deprecated
     */
    DESTINATION_LOCKED = "DESTINATION_LOCKED",
    UNPROCESSABLE_ENTITY = "UNPROCESSABLE_ENTITY",
    LOCKED = "LOCKED",
    FAILED_DEPENDENCY = "FAILED_DEPENDENCY",
    TOO_EARLY = "TOO_EARLY",
    UPGRADE_REQUIRED = "UPGRADE_REQUIRED",
    PRECONDITION_REQUIRED = "PRECONDITION_REQUIRED",
    TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
    REQUEST_HEADER_FIELDS_TOO_LARGE = "REQUEST_HEADER_FIELDS_TOO_LARGE",
    UNAVAILABLE_FOR_LEGAL_REASONS = "UNAVAILABLE_FOR_LEGAL_REASONS",
    INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
    NOT_IMPLEMENTED = "NOT_IMPLEMENTED",
    BAD_GATEWAY = "BAD_GATEWAY",
    SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE",
    GATEWAY_TIMEOUT = "GATEWAY_TIMEOUT",
    HTTP_VERSION_NOT_SUPPORTED = "HTTP_VERSION_NOT_SUPPORTED",
    VARIANT_ALSO_NEGOTIATES = "VARIANT_ALSO_NEGOTIATES",
    INSUFFICIENT_STORAGE = "INSUFFICIENT_STORAGE",
    LOOP_DETECTED = "LOOP_DETECTED",
    BANDWIDTH_LIMIT_EXCEEDED = "BANDWIDTH_LIMIT_EXCEEDED",
    NOT_EXTENDED = "NOT_EXTENDED",
    NETWORK_AUTHENTICATION_REQUIRED = "NETWORK_AUTHENTICATION_REQUIRED",
}

export const enum DeactivationRequestStatus {
    ACTIVE = "ACTIVE",
    APPROVED = "APPROVED",
    DECLINED = "DECLINED",
}

export const enum DayOfWeek {
    MONDAY = "MONDAY",
    TUESDAY = "TUESDAY",
    WEDNESDAY = "WEDNESDAY",
    THURSDAY = "THURSDAY",
    FRIDAY = "FRIDAY",
    SATURDAY = "SATURDAY",
    SUNDAY = "SUNDAY",
}

export const enum DayKindEnum {
    WEEKDAY = "WEEKDAY",
    WEEKEND = "WEEKEND",
    HOLIDAY = "HOLIDAY",
}

export const enum ContractReminderType {
    DASHBOARD = "DASHBOARD",
    EMAIL = "EMAIL",
}

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}


// Added by 'AxiosClientExtension' extension

import axios from "axios";
import * as Axios from "axios";

declare module "axios" {
    export interface GenericAxiosResponse<R> extends Axios.AxiosResponse {
        data: R;
    }
}

class AxiosHttpClient implements HttpClient<Axios.AxiosRequestConfig> {

    constructor(private axios: Axios.AxiosInstance) {
    }

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: Axios.AxiosRequestConfig; }): RestResponse<R> {
        function assign(target: any, source?: any) {
            if (source != undefined) {
                for (const key in source) {
                    if (source.hasOwnProperty(key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        }

        const config: Axios.AxiosRequestConfig = {};
        config.method = requestConfig.method as typeof config.method;  // `string` in axios 0.16.0, `Method` in axios 0.19.0
        config.url = requestConfig.url;
        config.params = requestConfig.queryParams;
        config.data = requestConfig.data;
        assign(config, requestConfig.options);
        const copyFn = requestConfig.copyFn;

        const axiosResponse = this.axios.request(config);
        return axiosResponse.then(axiosResponse => {
            if (copyFn && axiosResponse.data) {
                (axiosResponse as any).originalData = axiosResponse.data;
                axiosResponse.data = copyFn(axiosResponse.data);
            }
            return axiosResponse;
        });
    }
}

export class AxiosRestApplicationClient extends RestApplicationClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}
